import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {user} from '../../../store/reducers/user';
import {useTranslation} from 'react-i18next';
import Formatter from '../../../util/formatter';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import _ from 'lodash';
import AgyleDictionaryField from '../../../components/ui/selector/agyleDictionaryField';
import API from '../../../app/api';
import MiniFormDialog from '../../../components/modal/miniFormDialog';

const CURRENT_CLINICIAN_FORM_INIT = {
    specialty: null,
    consultant: null,
    who: null,
    login: null,
    when: null,
};

export function CurrentClinicianIpForm(props) {
    const {t} = useTranslation();

    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);

    const [activeSpecialties, setActiveSpecialties] = useState([]);
    const [originalConsultant, setOriginalConsultant] = useState([]);
    const [loadingDict, setLoadingDict] = useState(false);
    const [consultants, setConsultants] = useState([]);

    const [form, setForm] = useState(CURRENT_CLINICIAN_FORM_INIT);

    useEffect(() => {
        setForm((formLast) => {
            return {
                ...formLast,
                who: userFullName,
                login: userObject?.userName,
                when: moment().toISOString(),
            };
        });
    }, [userObject]);

    useEffect(() => {
        if (props.formData) {
            let formClone = _.cloneDeep(props.formData);
            setForm({
                ...formClone,
                who: userFullName,
                login: userObject?.userName,
                when: moment().toISOString(),
            });
        }
    }, [props.formData]);

    useEffect(() => {
        if (props.changeFormData) {
            props.changeFormData(form);
        }
    }, [form]);

    // Filter consultant by selected specialty
    useEffect(() => {
        if (!_.isNil(form.specialty)) {
            const consultant = [];
            _.forEach(originalConsultant, element => {
                if (element?.specialties?.includes(form.specialty.__id)) {
                    consultant.push(element);
                }
            });

            setConsultants(_.sortBy(consultant, 'familyName'));
        } else {
            setConsultants([]);
        }
    }, [form.specialty]);

    const loadDict = async () => {
        let onlyActiveSpec = new Set();

        // Show only active specialties
        await API.getDictByURL(`/$dict/Specialties`)
            .then(async specData => {
                if (!_.isEmpty(specData?.__data)) {
                    // Load all consultants
                    await API.getDictByURL(`/consultants?$filter=${encodeURIComponent('deactivated ne true')}`)
                        .then(consultant => {
                            if (!_.isEmpty(consultant?.__data)) {
                                // Store consultants
                                setOriginalConsultant(consultant?.__data);

                                _.forEach(consultant?.__data, element => {
                                    if (!_.isEmpty(element.specialties)) {
                                        _.forEach(element.specialties, spec => {
                                            const find = _.find(specData?.__data, {__id: spec});
                                            // if spec is found add to set
                                            if (find) onlyActiveSpec.add(find);
                                        });
                                    }
                                });
                            }
                        });
                }
            });

        // Sort Specialties
        const sortedSpec = _.sortBy([...onlyActiveSpec], '__description');

        setActiveSpecialties(sortedSpec);
    };

    useEffect(() => {
        setLoadingDict(true);
        loadDict().then(() => setLoadingDict(false));
    }, []);

    const renderClinician = (opt) => {
        return `${opt.familyName}, ${opt.firstName}`;
    };

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12}>
                <AgyleDictionaryField
                    label={t('Specialty')}
                    getOptionLabel={option => option.__description}
                    options={activeSpecialties}
                    loading={loadingDict}
                    value={form?.specialty}
                    isOptionEqualToValue={(option, value) => option.__id === value.__id}
                    onChange={(event, newValue) => setForm(prevState => ({
                        ...prevState,
                        specialty: newValue,
                        consultant: null,
                    }))}
                    size="large"
                    noBorder={false}
                    withNewBackground
                />
            </Grid>

            <Grid item xs={12}>
                <AgyleDictionaryField
                    label={t('Consultant')}
                    getOptionLabel={renderClinician}
                    options={consultants}
                    loading={loadingDict}
                    value={form?.consultant}
                    isOptionEqualToValue={(option, value) => option.__id === value.__id}
                    onChange={(event, newValue) => setForm(prevState => ({
                        ...prevState,
                        consultant: newValue,
                    }))}
                    size="large"
                    noBorder={false}
                    withNewBackground
                />
            </Grid>
        </Grid>
    );
}

function CurrentClinicianIpModal(props) {
    const {t} = useTranslation();

    const [formData, setFormData] = useState(null);

    const handleSubmit = () => {
        if (props.onChange) {
            props.onChange([{
                    name: 'currentClinicianIP',
                    value: formData,
                }],
            );
        }
        if (props.onClose) props.onClose();
    };

    const formIsValid = () => {
        return formData && formData.specialty && formData.consultant;
    };

    return (
        <MiniFormDialog
            title={t(props._formTitle)}
            open={props.open}
            onClose={props.onClose}
            disableSubmit={props.disableSave || !formIsValid()}
            onSave={handleSubmit}
            formOptions={props._formOptions}
        >
            <CurrentClinicianIpForm
                formData={props.currentPatientInWard?.currentClinicianIP}
                changeFormData={setFormData}
            />
        </MiniFormDialog>
    );
}

export default CurrentClinicianIpModal;